import React from 'react';
import { Container, Typography, Box, Paper, Grid, Button } from '@mui/material';
import { HelpOutline as HelpIcon, Add as AddIcon } from '@mui/icons-material';

const GovernanceHelpdesk: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
            <HelpIcon sx={{ fontSize: 40 }} />
            Governance Helpdesk
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Submit requests and get support for data governance
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} sx={{ bgcolor: 'primary.main' }}>
          New Request
        </Button>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h3" sx={{ color: 'primary.main', fontWeight: 700 }}>12</Typography>
            <Typography variant="body1" color="text.secondary">Open Tickets</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h3" sx={{ color: '#4caf50', fontWeight: 700 }}>45</Typography>
            <Typography variant="body1" color="text.secondary">Resolved This Month</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h3" sx={{ color: '#2196f3', fontWeight: 700 }}>2.5h</Typography>
            <Typography variant="body1" color="text.secondary">Avg Response Time</Typography>
          </Paper>
        </Grid>
      </Grid>

      <Paper sx={{ p: 4, mt: 3, textAlign: 'center', background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)', border: '2px dashed #003366' }}>
        <Typography variant="h5" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
          🚧 Helpdesk System Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Features: Ticket management, SLA tracking, Knowledge base, Live chat, Request routing.
        </Typography>
      </Paper>
    </Container>
  );
};

export default GovernanceHelpdesk;
